<template>
  <div class="addInvensList">
    <div class="inventorys">
      <div class="mainTit">盘点单</div>
      <el-form :model="form" :rules="rules" ref="form">
        <div class="toptit">
          <span class="labelTit">盘点范围 </span>
          <el-select v-model="form.scope" placeholder="请选择盘点范围" style="width:160px;margin-right: 20px" @change="nventOpti">
            <el-option label="单次服务商品" :value="1"></el-option>
            <el-option label="整套服务商品" :value="2"></el-option>
            <el-option label="零售商品" :value="10"></el-option>
          </el-select>
        </div>
        <el-table :data="tableData" ref="multipleTable" :cell-class-name="tableRowClassName" class="myTable" style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
          <el-table-column align="center">
            <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
            <el-table-column align="center" prop="productNo" label="商品编号">
              <template slot-scope="scope">{{scope.row.productNo | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="productName" label="商品名称">
              <template slot-scope="scope">
                {{scope.row.productName | filterRow}}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="expiryDate" label="最近有效期" width='160'>
              <template slot-scope="{row,$index}">
                <el-form-item :prop="'expiryDate.'+$index" :rules="rules.expiryDate">
                  <el-date-picker type="date" placeholder="年/月/日" format="yyyy/MM/dd" v-model="form.expiryDate[$index]" style="width: 140px;" value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" :label="'可售库存' + (form.scope == 1 ? '(次)':(form.scope == 2 ? '(套)':'(件)'))">
            <el-table-column align="center" prop="availableCount" label="账面数量"></el-table-column>
            <el-table-column align="center" prop="realAvailableCount" label="实际数量">
              <template slot-scope="{row,$index}">
                <el-form-item :prop="'realAvailableCount.'+$index" :rules="rules.realAvailableCount">
                  <el-input v-model="form.realAvailableCount[$index]"  @keyup.native.enter="confirmNum(form.realAvailableCount[$index],$index,row.availableCount,1)"  @blur="confirmNum(form.realAvailableCount[$index],$index,row.availableCount,1)"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="寄存库存(套)" v-if="form.scope == 2">
            <el-table-column align="center" prop="depositCount" label="账面数量"></el-table-column>
            <el-table-column align="center" prop="realDepositCount" label="实际数量">
              <template slot-scope="{row,$index}">
                <el-form-item :prop="'realDepositCount.'+$index" :rules="rules.realAvailableCount">
                  <el-input v-model="form.realDepositCount[$index]"  @keyup.native.enter="confirmNum(form.realDepositCount[$index],$index,row.depositCount,2)" @blur="confirmNum(form.realDepositCount[$index],$index,row.depositCount,2)"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="12">
            <div class="toptit">盘点结果</div>
            <div class="results">
              <span>正常：</span>
              {{normalNum?normalNum : tableData.length}}个
              <span>异常：</span>
              {{abnormalNum}}个
            </div>
            <div class="toptit">盘点说明</div>
            <el-form-item prop="remarks" label-width="90px">
              <el-input type="textarea" v-model="form.remarks" style="width:80%;height:130px;margin:25px 0 0 0" placeholder="非必填，30字数限制" resize="none"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="peopleList">
            <el-form-item label="盘点人：" prop="checkPeople">
              <el-select v-model="form.checkPeople" value-key="staffId" placeholder="请选择员工" style="width:185px;">
                <el-option :label="i.staffName" :value="i" v-for="i in staffList" :key="i.staffId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="检查人：" prop="examPeople" :rules="rules.checkPeople">
              <el-select v-model="form.examPeople" value-key="staffId" placeholder="请选择员工" style="width:185px;">
                <el-option :label="i.staffName" :value="i" v-for="i in staffList" :key="i.staffId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="记录人：">{{$store.state.userInfo.staffName}}</el-form-item>
            <p class="redFont">*注：建议由不同人员去盘点</p>
          </el-col>
        </el-row>
        <el-row class="btnOptions">
          <el-button class="darkBtn" @click="onCancel">取消</el-button>
          <el-button class="redBtn" @click="onSubmit" :disabled="submitFlag">提交</el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script type="text/javascript">
import {queryAllStockList, allStaff, insertStockTaking } from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    const isvalidDate = (rule, value, callback) => {
      if (value == '' || !value) {
        callback(new Error("请选择最近有效期"));
        this.$message({
          type: "error",
          message: "请选择最近有效期"
        });
      }else{
        callback();
      }
    };
    // 数字,5位以内
    const isvalidateNumber = (rule, value, callback) => {
      if (Number(value) == 0 || value != null && value != "") {
        if (/^[0-9]\d*$/.test(value) == false) {
          callback(new Error("请输入正整数"));
          this.$message({
            type: "error",
            message: "请输入正整数"
          });
        } else if (Number(value) > 99999) {
          callback(new Error("不得超过99999"));
          this.$message({
            type: "error",
            message: "不得超过99999"
          });
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入实际数量"));
        this.$message({
          type: "error",
          message: "请输入实际数量"
        });
      }
    };
    return {
      tableData: [],
      form: {
        scope:1,
        expiryDate:[],
        realAvailableCount: [],
        realDepositCount: [],
        realPublicCount: [],
        subnum: [],
        remarks:'',
        checkPeople: "",
        examPeople: "",
        notePeople: ""
      },
      rules: {
        expiryDate:[// { type:'date', validator: isvalidDate, trigger: "change"}
        ],
        realAvailableCount: [{ type: "number", validator: isvalidateNumber, trigger: "blur" }],
        remarks: [// { required: true, message: "请输入盘点说明", trigger: "blur" },
          {min: 0,max: 30,message: "最多30个中文字符长度",trigger: "blur"}
        ],
        checkPeople:[
          {required: true,message: "请选择员工",trigger: "change"}
        ],
      },
      fullscreenLoading: false,
      dialogTableVisible: false, //修改手工费弹窗
      normalNum: 0, //正常
      abnormalNum: 0, //异常
      staffList:'',//所有员工
      submitFlag:false
    };
  },
  computed: {
    detailList(){
      let data = [];
      this.tableData.forEach((i,index)=>{
        data.push({
          productNo:i.productNo,
          productName:i.productName,
          availableCount:i.availableCount,
          realAvailableCount:this.form.realAvailableCount[index],
          differentAvailableCount: Math.abs(this.form.realAvailableCount[index] - i.availableCount),
          depositCount:i.depositCount,
          realDepositCount:this.form.realDepositCount[index],
          differentDepositCount: Math.abs(this.form.realDepositCount[index] - i.depositCount),
          expiryDate:this.form.expiryDate[index]
        })
      })
      return data;
    },
    stockData(){
      let data = {
        normalNum:this.normalNum,
        abnormalNum:this.abnormalNum,
        remarks:this.form.remarks,
        operatorId:this.form.checkPeople.staffId,
        operatorName:this.form.checkPeople.staffName,
        examinerId:this.form.examPeople.staffId,
        examinerName:this.form.examPeople.staffName,
        noteTakerId:this.$store.state.userInfo.staffId,
        noteTakerName:this.$store.state.userInfo.staffName,
        scope:this.form.scope,
        detailList:this.detailList
      }
      return data;
    }
  },
  created() {
    this.search();
  },
  methods: {
    nventOpti(){
      this.search();
    },
    async search(val) {
      this.fullscreenLoading = true;
      let res = await allStaff({
        status: '1',
        staffType:'1',
        deleteFlag:'0'
      });
      this.staffList = res.data;
      this.fullscreenLoading = false;
      queryAllStockList({
        serviceType:this.form.scope
      }).then(res=>{
        this.tableData = res.data;
        for(let i in this.tableData){
          this.form.realAvailableCount[i] = this.tableData[i].availableCount
          this.form.realDepositCount[i] = this.tableData[i].depositCount
          this.form.realPublicCount[i] = this.tableData[i].publicCount
        }
      })
    },
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
      if (rowIndex % 2 == 1) {
        return "highLight";
      }
      return "";
    },
    confirmNum(rowNum, rowIndex, num, type) { //实际，下标，现有，类型（1-可用，2-寄存）
      let $chooseNode = $(".myTable  tbody tr").eq(rowIndex).children("td");
      if (rowNum != num) {
        if (type == 1) {
          $chooseNode.eq(4).addClass("redLight");
          $chooseNode.eq(5).addClass("redLight");
        } else if (type == 2) {
          $chooseNode.eq(6).addClass("redLight");
          $chooseNode.eq(7).addClass("redLight");
        }
      } else {
        if (type == 1) {
          $chooseNode.eq(4).removeClass("redLight");
          $chooseNode.eq(5).removeClass("redLight");
        } else if (type == 2) {
          $chooseNode.eq(6).removeClass("redLight");
          $chooseNode.eq(7).removeClass("redLight");
        }
      }
      // 所有商品的实际库存数填写结束后，下方自动分析出盘点结果
      let nonormal = 0;
      $(".myTable").find(".el-table__body").find("tr").each(function(index, ele) {
          if ($(ele).children(".redLight").length != 0) {
            nonormal++;
          }
        });
      this.abnormalNum = nonormal;
      this.normalNum = this.tableData.length  - this.abnormalNum;
    },
    onCancel() {
      // 取消
      this.$confirm('取消盘点，不保存盘点结果，请确定是否取消', "提示",{
          distinguishCancelAndClose: true,
          confirmButtonText: '不取消',
          cancelButtonText: "确定取消",
          type: "warning"
        }
      ).then(() => {
        }).catch(action => {
          if (action === "cancel") {
            this.$message({
              type: "info",
              message: "已取消"
            });
            this.$router.push("/businessManagementCenter/inventory");
          }
        });
    },
    onSubmit() {// 提交
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$confirm('请再次确认盘点结果真实有效，提交后将按照盘点结果覆盖原库存数，务必确保数据准确',"提示",{
              distinguishCancelAndClose: true,
              type: "warning"
            }
          ).then(() => {
              this.submitFlag = true;
              insertStockTaking(this.stockData).then(res=>{
                this.$message({
                  type: res.code == 1 ? 'success':"error",
                  message: res.msg
                });
                if (res.code == 1) {// 继续操作
                  this.$router.push("/businessManagementCenter/inventory");
                }
                this.submitFlag = false;
              });
            }).catch(action => {
              this.submitFlag = false;
              if (action === "cancel") {
                this.$message({
                  type: "info",
                  message: "已取消"
                });
              }
            });
        }else {
          this.submitFlag = false;
          console.log("error submit!!");
          return false;
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.inventorys {
  padding: 25px 0;
  .redFont {
    color: #f83b56; //红色字
  }
  .mainTit {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
  }
  .toptit {
    margin-top: 25px;
  }
  .myTable {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .tableGoods {
      .myTitle {
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .results {
    margin-top: 25px;
    span {
      color: #666;
      font-size: 13px;
      margin-left: 90px;
    }
  }
  .peopleList {
    margin: 20px 0 0;
    .el-form-item {
      margin-bottom: 40px;
    }
  }
  .btnOptions {
    text-align: center;
    margin: 45px;
    .el-button {
      width: 110px;
      height: 45px;
    }
  }
}
</style>
<style lang="less">
.addInvensList {
  .el-dialog__title {
    font-weight: bold;
  }
}
.myTable {
  .el-table__header {
    thead.is-group {
      tr {
        &:first-child {
          th {
            background: #fff !important;
          }
        }
      }
    }
  }
  .el-table__row {
    td {
      padding: 8px 0;
      .el-form-item__content {
        line-height: 28px;
      }
    }
  }
  .el-date-editor{
    .el-input__inner {
      width: 100%;
      height: 28px;
      line-height: 28px;
      text-align: center;
    }
    .el-input__icon{
      line-height: 28px;
    }
  }
  .el-input__inner {
    width: 82px;
    height: 28px;
    line-height: 28px;
    text-align: center;
  }
  .highLight {
    background: #eff1f5;
  }
  .redLight {
    background: #fedee3!important;
    color: #f83b56;
    .el-input__inner {
      color: #f83b56;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/addInventory.vue